import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: a flat round rug, 1.0 m diameter, 0.02 thick.
// The base disc is the darker border tone; a slightly smaller warm-neutral
// disc sits proud on top, leaving a thin border ring visible.
const BORDER = "#8a7a62";
const RUG = "#c9bfae";

export const roundRug = defineModel({
  id: "round-rug",
  batchId: "modern",
  name: "Round rug",
  tags: ["modern", "interior", "decor", "rug"],
  summary: "A flat round rug in a warm neutral tone with a thin border ring.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // border disc (its rim shows as the ring)
      { geometry: new THREE.CylinderGeometry(0.5, 0.5, 0.02, 24), color: BORDER, position: [0, 0.01, 0] },
      // inner rug surface proud of the border
      { geometry: new THREE.CylinderGeometry(0.44, 0.44, 0.012, 24), color: RUG, position: [0, 0.024, 0] },
    ];
  },
  animations: [],
});
